import api from './axios.js';

export const linksApi = {
  list: () => api.get('/links'),
  create: (data) => api.post('/links', data),
  delete: (id) => api.delete(`/links/${id}`),
};
